import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsBZ: CultureInfo = {
  name: 'es-BZ',
  displayName: 'español (Belice)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-BZ',
  parent: CultureInfoEs
};
